import React from 'react';
import { Menu } from 'semantic-ui-react';
import { reconciliationRegex } from '../constants/regex';
import RouteGeteway from '../utils/RouteGeteway';
import MenuReconciliation from './MenuReconciliation';

const MenuUnderTitle = () => {

    return (
        <RouteGeteway regex={reconciliationRegex}>
            <Menu className="sub-menu">
                <MenuReconciliation />
            </Menu>
        </RouteGeteway>    
    );
};

export default MenuUnderTitle;